import toast from "react-hot-toast";

// Thin wrapper around react-hot-toast with brand defaults.
// Use alongside existing inline status/message UI — this is additive.
export const notify = {
  success: (msg) => toast.success(msg),
  error:   (msg) => toast.error(msg),
  info:    (msg) => toast(msg, { icon: "ℹ️" }),
  loading: (msg) => toast.loading(msg),
  dismiss: (id)  => toast.dismiss(id),
};

// Bridge helper: given a { type, msg } status object (the pattern used across
// pages), fire the matching toast. Safe to call with null/undefined.
export function statusToast(status) {
  if (!status || !status.msg) return;
  if (status.type === "success") toast.success(status.msg);
  else if (status.type === "error") toast.error(status.msg);
  else toast(status.msg);
}

export default notify;
